export function getAddressFieldName(index: number) {
  return index === 0 ? 'route.source.address' : (`route.destination_${index}.address` as const)
}
